var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessCardsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 2425,
    viewBox: "0 0 646 2425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H546C596.81 8 638 49.1898 638 100V366.057C638 416.867 596.81 458.057 546 458.057H100C49.1898 458.057 8 499.247 8 550.057V856C8 906.81 49.1898 948 100 948H466.812",
    stroke: "#B880B7",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1974H546C596.81 1974 638 2015.19 638 2066V2424.06",
    stroke: "#B880B7",
    strokeWidth: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.832 948H546C596.81 948 638 989.19 638 1040V1363.51C638 1414.32 596.81 1455.51 546 1455.51H100C49.1898 1455.51 8 1496.7 8 1547.51V2008",
    stroke: "#B880B7",
    strokeWidth: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessCardsBg);
export default __webpack_public_path__ + "static/media/ProcessCardsBG.0d924a3fe1ac72dca97cb851b5cbda2a.svg";
export { ForwardRef as ReactComponent };